
import React from 'react'
import { withRouter, Route, Redirect } from 'react-router-dom'
import { compose } from 'recompose'
import AmenityServiceRoutePermission from './AmenityServiceRoutePermission'

class PrivateAmenityServiceRoute extends AmenityServiceRoutePermission {

    render() {
        let pathCurrent = this.getPathCurrent()
        if (!this.isAuthenticated() && pathCurrent !== "/amenityservice/login") {
            return <Redirect to={`/amenityservice/login`} />
        }
        let data = this.getComponentRoute()
        return <Route {...data.props} path={data.path} component={data.Component} />
    }
}

PrivateAmenityServiceRoute.defaultProps = {
    component: null,
    path: "",
}

const enhance = compose(
    withRouter,
)

export default enhance(PrivateAmenityServiceRoute)


// WEBPACK FOOTER //
// ./src/policy/PrivateAmenityServiceRoute.js